import { AfterViewInit, Component, inject, input, signal } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { ProductCardV2Component } from '../../product-card-v2/product-card-v2.component';

@Component({
  selector: 'app-suggested-products',
  imports: [ProductCardV2Component],
  templateUrl: './suggested-products.component.html',
  styleUrl: './suggested-products.component.scss'
})
export class SuggestedProductsComponent implements AfterViewInit {

  //#region Services

  #activeModal = inject(NgbActiveModal);

  //#endregion

  //#region Properties

  productsSource = input.required<any[]>();

  products = signal<any[]>([]);

  //#endregion

  //#region Constructor

  ngAfterViewInit(): void {
    this.products.set([...this.productsSource()]);
  }

  //#endregion

  //#region Methods

  close() {
    this.#activeModal.close();
  }

  removeProduct(productId: number) {
    this.products.update(value => {
      const index = value.findIndex(x => x.id === productId);
      if (index !== -1)
        value.splice(index, 1);
      return [...value];
    });

    if (!this.products().length)
      this.close();
  }

  //#endregion
}
